"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFMS = getFMS;
exports.getFMSGateway = getFMSGateway;
var _alphapointApexApi = require("alphapoint-apex-api");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ws = {
  gateway: null,
  connection: null
};

/**
 * Returns the FMS gateway URL once the FMS connection has been initialized.
 * Returns null before initialization so render-path callers don't crash.
 *
 * @returns {string | null}
 */
function getFMSGateway() {
  return ws.gateway || null;
}

/**
 * Gets the selected FMS gateway from localStorage or form state, with fallback to config
 *
 * @returns {string}
 */
function getSelectedFMSGateway() {
  var _config$FuturesTradin;
  // Get from localStorage (set by FMSGatewayComponent onSelect)
  var storedFMSGateway = localStorage.getItem('fmsGateway');
  if (storedFMSGateway) {
    return storedFMSGateway;
  }

  // Fallback to first gateway in config array or the config value if it's a string
  var configGateway = (_config$FuturesTradin = _config["default"].FuturesTrading) === null || _config$FuturesTradin === void 0 ? void 0 : _config$FuturesTradin.gateway;
  var fallbackGateway = Array.isArray(configGateway) ? configGateway[0] : configGateway;
  return fallbackGateway;
}

/**
 * Initiates the FMS WebSocket connection if not already initiated.
 *
 * @param {string} sessionToken Session Token received after the authorization in the main Gateway (APEX)
 * @param {string} [gateway] Gateway URL for the FMS service (optional). If not provided, the config `Futures.gateway` will be used.
 * @param {object} [options] WebSocket options (optional).
 * @returns {{ gateway: string | null; connection: object | null }}
 */
function getFMS(sessionToken, gateway) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (ws.connection) {
    return ws;
  }
  if (!sessionToken) {
    throw new Error('Session token is required');
  }
  ws.gateway = gateway || getSelectedFMSGateway();
  if (!ws.gateway) {
    throw new Error('FMS gateway is not provided or configured. Check the `Futures.gateway` configuration in the configuration file.');
  }
  ws.gateway = "".concat(ws.gateway, "?aptoken=").concat(sessionToken);
  ws.connection = new _alphapointApexApi.APEX(ws.gateway, _objectSpread({
    onopen: function onopen() {
      (options === null || options === void 0 ? void 0 : options.debug) && console.log('FMS WebSocket connection opened');
    },
    onclose: function onclose() {
      (options === null || options === void 0 ? void 0 : options.debug) && console.log('FMS WebSocket connection closed');
    },
    onerror: function onerror(error) {
      (options === null || options === void 0 ? void 0 : options.debug) && console.error('FMS WebSocket error:', error);
    }
  }, options));
  ws.connection.standardCallback = function () {};
  return ws;
}